"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var OfferCountryList_1 = require("./options/country/OfferCountryList");
var OfferCountryEditor_1 = require("./options/country/OfferCountryEditor");
var BrandOfferLocaleList_1 = require("./options/locale/BrandOfferLocaleList");
var BrandOfferLocaleEditor_1 = require("./options/locale/BrandOfferLocaleEditor");
var BrandOffersOperationsConfig = /** @class */ (function (_super) {
    __extends(BrandOffersOperationsConfig, _super);
    function BrandOffersOperationsConfig(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_offer_country = "offer.country";
        _this.tab_offer_locales = "offer.locales";
        return _this;
    }
    BrandOffersOperationsConfig.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.listAvailAppCountries.Subscribe("*", function (id, data) {
            _this.setState({ availCountry: data.data });
        });
        this.SID_AL = this.props.listAvailAppLanguages.Subscribe("*", function (id, data) {
            _this.setState({ availLanguage: data.data });
        });
        this.setState({
            OfferCountryMode: "LIST",
            OfferCountryRecord: null,
            OfferLocaleMode: "LIST",
            OfferLocaleRecord: null,
            availCountry: [],
            availLanguage: []
        }, function () {
            _this.props.listAvailAppCountries.LoadData();
            _this.props.listAvailAppLanguages.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["Настройки оффера"]);
    };
    BrandOffersOperationsConfig.prototype.componentWillUnmount = function () {
        this.props.listAvailAppCountries.UnSubscribe(this.SID_AC);
        this.props.listAvailAppLanguages.UnSubscribe(this.SID_AL);
    };
    BrandOffersOperationsConfig.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BrandOffersOperationsConfig.prototype.newAppCountryClick = function () {
        this.setState({ OfferCountryMode: "NEW", OfferCountryRecord: null });
    };
    BrandOffersOperationsConfig.prototype.editAppCountryClick = function (record) {
        this.setState({ OfferCountryMode: "EDIT", OfferCountryRecord: record });
    };
    BrandOffersOperationsConfig.prototype.backToAppCountryListClick = function () {
        this.setState({ OfferCountryMode: "LIST", OfferCountryRecord: null });
    };
    BrandOffersOperationsConfig.prototype.getAPPCountryObject = function () {
        if (this.state.OfferCountryMode === "LIST") {
            return (React.createElement(OfferCountryList_1.default, { state: this.props.state, data: this.props.dataOffersCountries, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.newAppCountryClick.bind(this), onEditClick: this.editAppCountryClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.OfferCountryMode === "NEW") {
            return (React.createElement(OfferCountryEditor_1.default, { data: this.props.dataOffersCountries, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppCountryListClick.bind(this), availCountry: this.state.availCountry }));
        }
        if (this.state.OfferCountryMode === "EDIT") {
            return (React.createElement(OfferCountryEditor_1.default, { data: this.props.dataOffersCountries, record: this.state.OfferCountryRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppCountryListClick.bind(this), availCountry: this.state.availCountry }));
        }
        throw "No available render for active edit mode -> " + this.state.OfferCountryMode;
    };
    BrandOffersOperationsConfig.prototype.newFormulaClick = function () {
        this.setState({ OfferLocaleMode: "NEW", OfferLocaleRecord: null });
    };
    BrandOffersOperationsConfig.prototype.editFormulaClick = function (record) {
        this.setState({ OfferLocaleMode: "EDIT", OfferLocaleRecord: record });
    };
    BrandOffersOperationsConfig.prototype.backToLocalesListClick = function () {
        this.setState({ OfferLocaleMode: "LIST", OfferLocaleRecord: null });
    };
    BrandOffersOperationsConfig.prototype.getFormulaObject = function () {
        if (this.state.OfferLocaleMode === "LIST") {
            return (React.createElement(BrandOfferLocaleList_1.default, { state: this.props.state, data: this.props.dataOffersLocales, onGoBackClick: this.backToRootClick.bind(this), onNewClick: this.newFormulaClick.bind(this), onEditClick: this.editFormulaClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.OfferLocaleMode === "NEW") {
            return (React.createElement(BrandOfferLocaleEditor_1.default, { data: this.props.dataOffersLocales, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLocalesListClick.bind(this), availLanguage: this.state.availLanguage }));
        }
        if (this.state.OfferLocaleMode === "EDIT") {
            return (React.createElement(BrandOfferLocaleEditor_1.default, { data: this.props.dataOffersLocales, record: this.state.OfferLocaleRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToLocalesListClick.bind(this), availLanguage: this.state.availLanguage }));
        }
        throw "No available render for active edit mode -> " + this.state.OfferLocaleMode;
    };
    BrandOffersOperationsConfig.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_offer_country },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "globe" }),
                        "\u0421\u0442\u0440\u0430\u043D\u044B"), key: this.tab_offer_country }, this.getAPPCountryObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "flag" }),
                        "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438"), key: this.tab_offer_locales }, this.getFormulaObject()))));
    };
    return BrandOffersOperationsConfig;
}(React.Component));
exports.default = BrandOffersOperationsConfig;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_offers_list/ui/component/BrandsOffersOperationsConfig.tsx
// module id = 2425
// module chunks = 0